import React, { useState, useEffect } from "react";
import { API_ENDPOINTS } from "../../../api/endpoints";

const ModalLiberacion = ({ cargaId, onClose }) => {
  const [estado, setEstado] = useState("confirmacion");

  const liberarCarga = async () => {
    setEstado("cargando");

    const apiLiberaProcesoCarga = API_ENDPOINTS.interna.LiberaProcesoCarga(cargaId);
    try {
      const res = await fetch(apiLiberaProcesoCarga);
      if (!res.ok) throw new Error("Error en la solicitud");
      setTimeout(() => setEstado("exito"), 1000);
    } catch {
      setTimeout(() => setEstado("error"), 1000);
    }
  };

  useEffect(() => {
    if (cargaId) setEstado("confirmacion");
  }, [cargaId]);

  useEffect(() => {
    if (estado === "exito") {
      setTimeout(() => {
        onClose();
      }, 2000);
    }
  }, [estado, onClose]);

  if (!cargaId) return null;

  const renderContenido = () => {
    switch (estado) {
      case "cargando":
        return (
          <div className="modal-body text-center py-4">
            <div className="spinner-border text-primary mb-3" role="status" />
            <h4>Cargando...</h4>
            <div className="text-secondary">Procesando liberación de carga</div>
          </div>
        );
      case "exito":
        return (
          <div className="modal-body text-center py-4">
            <svg className="icon mb-2 text-success icon-lg" width="24" height="24" stroke="currentColor" fill="none">
              <path d="M5 12l5 5l10 -10" />
            </svg>
            <h4>¡Carga liberada!</h4>
            <div className="text-secondary">Se liberó correctamente</div>
          </div>
        );
      case "error":
        return (
          <div className="modal-body text-center py-4">
            <svg className="icon mb-2 text-danger icon-lg" width="24" height="24" stroke="currentColor" fill="none">
              <path d="M12 9v2m0 4v.01" />
              <path d="M5 19h14a2 2 0 0 0 1.84 -2.75L12.75 4a2 2 0 0 0 -3.5 0L2.15 16.25A2 2 0 0 0 3.9 19" />
            </svg>
            <h4>Ocurrió un error</h4>
            <div className="text-secondary">No se pudo liberar la carga. Intenta nuevamente.</div>
          </div>
        );
      default:
        return (
          <div className="modal-body text-center py-4">
            <h3>¿Estás seguro?</h3>
            <div className="text-secondary">Esta acción no se puede deshacer.</div>
          </div>
        );
    }
  };

  return (
    <>
      <div className="modal-backdrop fade show" style={{ zIndex: 1050 }}></div>
      <div className="modal show d-block" tabIndex="-1" role="dialog">
        <div className="modal-dialog modal-sm" role="document">
          <div className="modal-content">
            {estado !== "cargando" && <button type="button" className="btn-close" onClick={onClose} aria-label="Close"></button>}
            <div className={`modal-status ${estado === "error" ? "bg-danger" : estado === "exito" ? "bg-success" : "bg-warning"}`} />
            {renderContenido()}
            {estado === "confirmacion" && (
              <div className="modal-footer">
                <div className="row w-100">
                  <div className="col">
                    <button className="btn w-100" onClick={onClose}>
                      Cancelar
                    </button>
                  </div>
                  <div className="col">
                    <button className="btn btn-warning w-100" onClick={liberarCarga}>
                      Sí, liberar
                    </button>
                  </div>
                </div>
              </div>
            )}
          </div>
        </div>
      </div>
    </>
  );
};

export default ModalLiberacion;
